import * as Dialog from "@radix-ui/react-dialog";

import { LoadingCircle } from "../Icon";
import { LoadingToastProps } from "./type";

export const LoadingToast = ({
  isLoading,
  description = "読み込み中です...",
  visibleOverlay = true,
}: LoadingToastProps) => (
  <Dialog.Root open={isLoading}>
    <Dialog.Portal>
      {visibleOverlay && <Dialog.Overlay className="bg-background-gray500 z-overlay fixed inset-0 opacity-50" />}
      <Dialog.Content className=" bg-ui-100 opacity z-toast fixed left-1/2 top-4 -translate-x-1/2 rounded focus:outline-none">
        <Dialog.Title className="text-ui14 text-ui-400 shadow-mid flex w-[350px] max-w-[350px] items-center justify-center gap-2 rounded px-6 py-3">
          <span className="h-6 w-6">
            <LoadingCircle className="fill-grayScale-400 animate-spin" />
          </span>
          <div className="line-clamp-1 font-bold">{description}</div>
        </Dialog.Title>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
